var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareReels(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_3298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 22.9992V15.9993C0.00264685 13.6131 0.951708 11.3255 2.63896 9.63822C4.32622 7.95097 6.61386 7.00191 9 6.99927H13.83V5.41327C13.8301 5.01777 13.9474 4.63117 14.1672 4.30235C14.387 3.97353 14.6993 3.71725 15.0647 3.56591C15.4301 3.41457 15.8322 3.37497 16.2201 3.4521C16.608 3.52924 16.9643 3.71965 17.244 3.99927L23.124 9.87826C23.6864 10.4408 24.0024 11.2038 24.0024 11.9993C24.0024 12.7948 23.6864 13.5577 23.124 14.1203L17.244 19.9992C16.9643 20.2789 16.608 20.4693 16.2201 20.5464C15.8322 20.6235 15.4301 20.5839 15.0647 20.4326C14.6993 20.2813 14.387 20.025 14.1672 19.6962C13.9474 19.3673 13.8301 18.9808 13.83 18.5852V16.9993H8C6.40919 17.0008 4.88399 17.6335 3.75911 18.7584C2.63424 19.8832 2.00159 21.4084 2 22.9992C2 23.2645 1.89464 23.5188 1.70711 23.7063C1.51957 23.8939 1.26522 23.9992 1 23.9992C0.734784 23.9992 0.48043 23.8939 0.292893 23.7063C0.105357 23.5188 0 23.2645 0 22.9992ZM15.83 7.99926C15.83 8.26448 15.7246 8.51883 15.5371 8.70637C15.3496 8.89391 15.0952 8.99926 14.83 8.99926H9C7.14414 9.00138 5.36489 9.73956 4.05259 11.0519C2.7403 12.3641 2.00212 14.1434 2 15.9993V17.7133C2.74957 16.8602 3.67249 16.1768 4.70715 15.7088C5.74182 15.2408 6.86441 14.9989 8 14.9993H14.83C15.0952 14.9993 15.3496 15.1046 15.5371 15.2921C15.7246 15.4797 15.83 15.734 15.83 15.9993V18.5852L21.709 12.7063C21.8965 12.5187 22.0018 12.2644 22.0018 11.9993C22.0018 11.7341 21.8965 11.4798 21.709 11.2923L15.83 5.41327V7.99926Z",
    fill: "#374957"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_3298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareReels);
export default __webpack_public_path__ + "static/media/shareReels.6f4814b7f7de31ba2db7e5fa834e83d3.svg";
export { ForwardRef as ReactComponent };